module.exports = __webpack_public_path__ + "static/media/5.4a9aa1c9.webp";